import { useState } from 'react';
import LevelBar from './LevelBar';

export default function CategoryInsightCard({
  title,
  what,
  level,
  levelClass,
  score,
  meaning,
  detail,
}) {
  const [open, setOpen] = useState(false);

  return (
    <article className="insight-card">
      <h4 className="insight-card__title">{title}</h4>
      <LevelBar score={score} levelClass={levelClass} level={level} />
      <p className="insight-card__meaning">{meaning}</p>
      {detail && (
        <>
          <button
            type="button"
            className="insight-card__toggle"
            onClick={() => setOpen(!open)}
          >
            {open ? 'Hide details' : 'Show technical details'}
          </button>
          {open && <p className="insight-card__detail">{detail}</p>}
        </>
      )}
    </article>
  );
}
